import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`
width:100%;


font-size: max(1vw,10px);
text-align:center;
color: ${theme.colors.dark};
font-weight: bold;
`;

export const Title = styled.span`
font-size: max(1vw, 8px);
font-weight: bold;
`;

export const ContainerInterno = styled.div`
width:100%;
border:solid 1px ${theme.colors.dark};


`;
export const Section = styled.section`
    display:flex;
    align-items: center;
    justify-content:space-around;
margin-bottom:0.4vh ;
`;




export const ContainerValue = styled.div`

width:100%;
display: flex;
align-items: flex-start;
flex-direction: column;
font-size: max(1vw, 8px);

`;

export const Values = styled.div`
    width:100%;
    border:solid 1px ${theme.colors.dark};
    padding: 0.5vh 1vw;
    font-size: max(1vw, 6px);

`;



